
import {defineComponent} from "vue";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import TradeContractFormatGroupForm
  from "@/components/pages/contract/TradeContractFormatGroup/TradeContractFormatGroupForm.vue";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import {mapActions, mapGetters, mapMutations} from "vuex";
import {AxiosInstance} from "axios";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import SelectedFormatTab
  from "@/components/pages/contract/TradeContractFormatGroup/SelectedFormatTab.vue";

export default defineComponent({
  name: 'TradeContractFormatGroup',
  components: {SelectedFormatTab, TabItemTemplate, TextFieldLike, TableInline, IconBtn, TradeContractFormatGroupForm, FormPageTemplate},
  mixins: [
    IoablePageMixin,
  ],
  inject: [
      'mainBounds',
  ],
  props: {
    tradeContractFormatGroupId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      dirty: false,
      group: {} as TradeContractFormatGroup,
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      _hcsClient: 'hcs/client',
    }),
    hcsClient(): AxiosInstance {
      return this._hcsClient as AxiosInstance;
    },
    readonly(): boolean {
      return !this.$route.name?.startsWith('/edit/');
    },
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormatGroups: "hcs/tradeContractFormatGroup/findList",
      fetchTradeContractFormatGroup: "hcs/tradeContractFormatGroup/get",
      updateTradeContractFormatGroup: "hcs/tradeContractFormatGroup/update",
    }),
    ...mapMutations({
      showSnackbar: 'showSnackbar',
    }),
    async load() {
      this.group = await this.fetchTradeContractFormatGroup(this.tradeContractFormatGroupId);
    },
    async save() {
      await this.updateTradeContractFormatGroup(this.group);
    }
  }
});
